import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CONFIG } from 'src/helper/app-config';
import { DataService } from '../data.service';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule } from '@angular/common';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { FormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';
import { BaseScenarioComponent } from './base-scenario/base-scenario.component';
import { ScenarioBuilderComponent } from './scenario-builder/scenario-builder.component';

@Component({
  selector: 'app-scenario-creation',
  standalone: false,
  templateUrl: './scenario-creation.component.html',
  styleUrl: './scenario-creation.component.scss',
})
export class ScenarioCreationComponent {
  hello = true;
  isBaseScenarioCreated = true;
  isPriceScenarioCreated = true;
  isOutputScreenActive = false;
  tabs = CONFIG.TABS.map((val) => val);
  activeTab: any = 'Create Base Scenario';
  // activeTab: any = 'View Output Summary';
  userType;
  usreConfig = CONFIG.USER_TYPES;
  baseDetails: any = {};
  childDetails: any = {};
  duplicateId;
  aggData;
  constructor(
    private router: Router,
    private dataService: DataService,
    private route: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.dataService.userType.subscribe((val) => {
      this.userType = val;
    });

    this.route.queryParams.subscribe((params) => {
      console.log(params);
      this.baseDetails = params?.['baseDetails'];
      if (this.baseDetails) {
        this.baseDetails = JSON.parse(this.baseDetails);
      }

      this.childDetails = params?.['childDetails'];
      if (this.childDetails) {
        this.childDetails = JSON.parse(this.childDetails);
      }
      if (params['aggData']) {
        this.aggData = JSON.parse(params['aggData']);
      }
      this.duplicateId = params?.['duplicateId'];

      if (params['tab']) {
        this.moveLevel(this.tabs[parseInt(params['tab'])]);
      }
    });
  }
  showCompleted(index) {
    // if (index === 0) {
    //   return true;
    // }
    if (this.tabs.indexOf(this.activeTab) !== index) {
      return false;
    }
    return true;
  }
  isEmptyObject(obj) {
    if (!obj) {
      return true;
    }
    return Object.keys(obj).length === 0;
  }
  moveLevel(tab, baseObj?) {
    if (!baseObj) {
      baseObj = {};
    }
    if (tab === 'Create Base Scenario') {
      // if (this.userType !== this.usreConfig.MANG) {
      //   Swal.fire({
      //     icon: 'error',
      //     title: 'Not Authorized!',
      //     text: 'Only Managers can able to create base scenario',
      //     // footer: '<a href="">Why do I have this issue?</a>'
      //   }).then((res) => {
      //     this.router.navigate(['/library']);
      //   });
      //   return;
      // }
    }
    let destinationIndex = this.tabs.indexOf(tab);
    if (this.baseDetails && this.childDetails) {
      destinationIndex = this.tabs.indexOf('View Output Summary');
    }

    if (this.baseDetails && !this.childDetails) {
      destinationIndex = this.tabs.indexOf('Create Price Scenario');
    }
    let currentIndex = this.tabs.indexOf(this.activeTab);
    // if (destinationIndex < currentIndex) {
    // this.placementState.setActiveTab(tab);
    this.activeTab = this.tabs[destinationIndex];
    this.router.navigate(['/scenario-creation'], {
      queryParams: {
        tab: destinationIndex,
        baseDetails: Object.keys(baseObj).length
          ? JSON.stringify(baseObj)
          : JSON.stringify(this.baseDetails),
        childDetails: JSON.stringify(this.childDetails),
        aggData: JSON.stringify(this.aggData),
        duplicateId: this.duplicateId,
      },
    });

    // }
  }
  checkStatus(i) {
    if (i !== this.tabs.indexOf(this.activeTab)) {
      return true;
    }
    return false;
  }

  goBack() {
    let index = this.tabs.indexOf(this.activeTab);
    if (index > 0) {
      this.activeTab = this.tabs[index];
    }
    //  else {
    //   this.router.navigate(['/' + CONFIG.PATH.SCENARIO_LIBRARY]);
    // }
  }
}
